<template>
  <v-app light>
    <v-navigation-drawer fixed v-model="drawer" app v-if="userIsAuthenticated">
      <v-list>
        <v-list-tile router to="/" exact>
          <v-list-tile-action>
            <v-icon light>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && ['Sales', 'Admin', 'Admin and Engineer'].indexOf(role) !== -1"
          router to="/NewOrder">
          <v-list-tile-action>
            <v-icon light>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>New Order</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="access.viewAllJobs === true && ['Support', 'Support and Engineer', 'Sales', 'Admin', 'Admin and Engineer'].indexOf(role) !== -1"
          router to="/OrderApproval">
          <v-list-tile-action>
            <v-icon light v-if="role === 'Sales'">close</v-icon>
            <v-icon light
              v-else-if="['Support', 'Support and Engineer', 'Admin', 'Admin and Engineer'].indexOf(role) !== -1">mdi-approval</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-if="role === 'Sales'">Rejected Orders</v-list-tile-title>
            <v-list-tile-title
              v-else-if="['Support', 'Support and Engineer', 'Admin', 'Admin and Engineer'].indexOf(role) !== -1">Approve
              Orders</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/ServiceCalls">
          <v-list-tile-action>
            <v-icon light>assignment_late</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Service Calls</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/Project">
          <v-list-tile-action>
            <v-icon light>mdi-file-tree</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Projects</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="$router.currentRoute.name === 'Project'">
            <v-btn icon @click="$router.go()"><v-icon light>refresh</v-icon></v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/Jobs">
          <v-list-tile-action>
            <v-icon light>mdi-file-document-box</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Jobs</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/Finance">
          <v-list-tile-action>
            <v-icon light>mdi-credit-card</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Finance</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/Customer">
          <v-list-tile-action>
            <v-icon light>mdi-account-group</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Customers</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/Products">
          <v-list-tile-action>
            <v-icon light>mdi-sitemap</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Products</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/Admin/Vehicle">
          <v-list-tile-action>
            <v-icon light>local_shipping</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Vehicles</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.suppliers === true" router to="/Supplier">
          <v-list-tile-action>
            <v-icon light>assignment_ind</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Suppliers</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile router v-if="access.viewAllJobs === true && role !== 'Supplier'" to="/Calendar">
          <v-list-tile-action>
            <v-icon light>event</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Calendar</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/Sites">
          <v-list-tile-action>
            <v-icon light>domain</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sites</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/Contacts">
          <v-list-tile-action>
            <v-icon light>contacts</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Contacts</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="access.viewAllJobs === true && role !== 'Supplier'" router to="/BulkSMS">
          <v-list-tile-action>
            <v-icon light>message</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Bulk SMS</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-group v-if="access.viewAllJobs === true && role !== 'Supplier'" prepend-icon="device_hub">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Devices</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile router to="/Devices">
            <v-list-tile-action>
              <v-icon light>router</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Hardware Devices</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile router to="/Sims">
            <v-list-tile-action>
              <v-icon light>sim_card</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>SIMs</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-list-tile v-if="access.admin === true" router to="/Admin">
          <v-list-tile-action>
            <v-icon light>verified_user</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Admin</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="mt-5 mb-2"></v-divider>
        <v-list-tile router to="/settings" v-if="userIsAuthenticated">
          <v-list-tile-action>
            <v-icon light>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile router v-if="userIsAuthenticated" @click="onLogout">
          <v-list-tile-action>
            <v-icon light>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Log Out</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app color="secondary" dark>
      <v-toolbar-side-icon v-if="userIsAuthenticated" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <img src="../static/img/cubo-icon.png" width="50" />
    </v-toolbar>
    <v-alert :value="newVersion" color="accent" icon="history"
      style="position: fixed;top: 60px;width: 100%;z-index: 100;">A
      new version is available <v-btn color="success" @click="update" depressed>Update</v-btn></v-alert>
    <v-content>
      <router-view :key="$route.fullPath"></router-view>
    </v-content>
    <!-- <v-snackbar
      :timeout="10000"
      color="primary"
      multi-line
      vertical
      v-model="newVersion"
      right
    >
    A new version is available
    <v-btn dark flat @click.native="update()">Update</v-btn>
    </v-snackbar> -->
  </v-app>
</template>

<script>
import { fireStore } from './firebase'
export default {
  data() {
    return {
      drawer: false,
      fixed: false,
      title: 'nexus',
      newVersion: false
    }
  },
  computed: {
    userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading() {
      return this.$store.getters.loading
    },
    name() {
      return this.$store.getters.userData.Name
    },
    role() {
      return this.$store.getters.userData.Role
    },
    access() {
      return this.$store.getters.userData.Access
    }
  },
  created() {
    fireStore.collection('Versions').doc('Portal').get()
      .then(doc => {
        if (doc.data().Version !== 3.40) { // changed > to !==, means if we have to roll back a version then the user will be able to 'update' to a lower version
          this.newVersion = true
        }
      })
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // logProjectClick () {
    //   console.log(this.$route)
    //   if (this.$route.name === 'Project') {
    //     this.$router.replace('/Project/null')
    //   }
    // },
    onLogout() {
      this.$store.dispatch('logout')
      this.$router.push('/SignIn')
    },
    update() {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister()
        }
      })
        .then(function (boolean) {
          caches.delete('v1-engineerportal-cache').then(function (boolean) {
            window.location.reload(true)
          })
        })
    }
  }
}
</script>

<style>
@font-face {
  font-family: "gilroy";
  src: url("../static/fonts/Gilroy-Regular.ttf");
}

.application {
  font-family: "gilroy";
}
</style>


// WEBPACK FOOTER //
// App.vue?14c64f12